import React from 'react';

const Loader = () => {
    return (
        <div className="animate-pulse space-y-6">
            <div className="h-screen bg-gray-700 rounded-lg"></div>
        </div>
    );
};

export default Loader;
